import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThermometer = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5 1C9.567 1 8 2.567 8 4.5V13.2572C6.7785 14.266 6 15.7921 6 17.5C6 20.5376 8.46243 23 11.5 23C14.5376 23 17 20.5376 17 17.5C17 15.7921 16.2215 14.266 15 13.2572V4.5C15 2.567 13.433 1 11.5 1Z",
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5 2C10.1193 2 9 3.11929 9 4.5V13.7578C7.79401 14.565 7 15.9398 7 17.5C7 19.9853 9.01472 22 11.5 22C13.9853 22 16 19.9853 16 17.5C16 15.9398 15.206 14.565 14 13.7578V4.5C14 3.11929 12.8807 2 11.5 2Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 17.5,
			r: 2.5,
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 8,
			width: 1,
			height: 8,
			rx: .5,
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 5,
			width: 4,
			height: 1,
			rx: .5,
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 7,
			width: 2,
			height: 1,
			rx: .5,
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 9,
			width: 4,
			height: 1,
			rx: .5,
			fill: "#293235"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 11,
			width: 2,
			height: 1,
			rx: .5,
			fill: "#293235"
		})
	]
});
const ForwardRef = forwardRef(SvgThermometer);
export { ForwardRef as ReactComponent };
